var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2175 5.31369L6.7475 9.78369L4.2775 7.31369C3.9875 7.02369 3.5075 7.02369 3.2175 7.31369C2.9275 7.60369 2.9275 8.08369 3.2175 8.37369L6.7475 11.9037L12.2775 6.37369C12.5675 6.08369 12.5675 5.60369 12.2775 5.31369C11.9875 5.02369 11.5075 5.02369 11.2175 5.31369Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCheck);
export default __webpack_public_path__ + "static/media/img_check.0ee91260c35094d4679c4ebec21fa7ec.svg";
export { ForwardRef as ReactComponent };